import { injectable, injectFromBase } from 'inversify'
import OrmLocalStorageRepository from '@/data/repositories/ormLocalStorageRepository'
import OAuthSignUp from '@/data/models/OAuthSignUp'
import { RepoSettings } from '@/decorators/repositoryDecorators'

@RepoSettings({
  model: OAuthSignUp,
  fetch: OAuthSignUp.entity,
  create: OAuthSignUp.entity,
  single: OAuthSignUp.entity,
})
@injectable()
@injectFromBase()
export default class OAuthSignUpRepository extends OrmLocalStorageRepository<OAuthSignUp> {
  protected id = '1'

  public async fetchOAuthSignUpData(): Promise<OAuthSignUp | null> {
    const data = await this.getRequest(this.id)

    if (!data) {
      return null
    }

    await this.storeOAuthSignUpData(data)
    return this.getOAuthSignUpData()
  }

  public getOAuthSignUpData(): OAuthSignUp | null {
    return this.findEntityByIdOrNull(this.id)
  }

  public async storeOAuthSignUpData(
    signUpData: Pick<OAuthSignUp, 'token' | 'username' | 'firstName' | 'lastName' | 'email'>,
  ) {
    await this.postRequest({
      ...signUpData,
      id: this.id,
    })
    await this.fill(this.id)
  }

  public clearOAuthSignUpData() {
    return this.deleteRequest(this.id)
  }
}
